import "./Login.css";

function LockIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

function Login({ onSubmit, password, setPassword, error }) {
  return (
    <section className="login-section">
      <div className="login-card">
        <div className="login-icon">
          <LockIcon />
        </div>

        <div className="login-header">
          <h2 className="login-title">Password Protected</h2>
          <p className="login-desc">
            This case study is private. Enter the password to view it.
          </p>
        </div>

        <form className="login-form" onSubmit={onSubmit}>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`login-input${error ? " error-field" : ""}`}
            autoComplete="current-password"
          />
          {error && (
            <p className="login-error">Incorrect password. Please try again.</p>
          )}
          <button type="submit" className="login-submit">
            Unlock
          </button>
        </form>
      </div>
    </section>
  );
}

export default Login;
